export const mobileLayoutContentPadding = 2;
export const DEFAULT_FIAT_CURRENCY_NAME = 'EUR';
export const DEFAULT_FIAT_CURRENCY_SIGN = '€';
export const USD_CURRENCY_NAME = 'USD';
export const USD_CURRENCY_SIGN = '$';
